import { RoleTypes, CombinedFlows } from "./flow-types";

export function detectPullFlowAvailableRoles(dataElement, identity = null) {
	if (!dataElement || (!dataElement.from && !dataElement.from_agents)) {
		return {
			hasConsumerFromContributor: false,
			hasCOB: false,
			hasCOBOP: false,
			hasConsumerFromAgent: false,
			roles: [],
		};
	}

	const roles = new Set();
	let hasCOB = false;
	let hasCOBOP = false;
	let hasConsumerFromContributor = false;
	let hasConsumerFromAgent = false;

	const currentOrgId = identity?.organization?.id || null;

	if (dataElement?.from && Array.isArray(dataElement?.from)) {
		dataElement?.from.forEach((participant) => {
			// Check for COBOP (for_principals exists)
			if (participant.for_principals?.length > 0) {
				hasCOBOP = true;
				roles.add(RoleTypes.CONSUMER_ON_BEHALF_OF_PRINCIPALS);
			}

			if (participant.on_behalf_of?.length > 0) {
				// COB only if on_behalf_of contains OTHER organizations (not current org)
				const hasOtherOrgs = participant.on_behalf_of.some(
					(consumer) => consumer.id !== currentOrgId
				);

				if (hasOtherOrgs) {
					hasCOB = true;
					roles.add(RoleTypes.CONSUMER_ON_BEHALF_OF);
				}

				// Check if current org is in on_behalf_of (direct consumption)
				const hasCurrentOrg = participant.on_behalf_of.some(
					(consumer) => consumer.id === currentOrgId
				);

				// Ensure it's a direct consumption and is not consuming on behalf of any principals
				if (hasCurrentOrg && !participant.for_principals) {
					hasConsumerFromContributor = true;
					roles.add(RoleTypes.CONSUMER_FROM_CONTRIBUTOR);
				}
			}
		});
	}

	if (dataElement.from_agents?.length > 0) {
		hasConsumerFromAgent = true;
		roles.add(RoleTypes.CONSUMER_OR_RECEIVER_FROM_AGENT);
	}

	return {
		hasConsumerFromContributor,
		hasCOB,
		hasCOBOP,
		hasConsumerFromAgent,
		roles: Array.from(roles),
	};
}

export function determinePullFlowCombinedFlow(roles) {
	const { hasConsumerFromContributor, hasCOB, hasCOBOP } = roles;

	if (hasConsumerFromContributor && hasCOB && hasCOBOP) {
		return CombinedFlows.CONSUMER_COB_COBOP;
	}

	if (hasCOB && hasCOBOP && !hasConsumerFromContributor) {
		return CombinedFlows.COB_COBOP;
	}

	if (hasConsumerFromContributor && hasCOBOP && !hasCOB) {
		return CombinedFlows.CONSUMER_COBOP;
	}

	if (hasConsumerFromContributor && hasCOB && !hasCOBOP) {
		return CombinedFlows.CONSUMER_COB;
	}

	if (hasCOBOP && !hasCOB && !hasConsumerFromContributor) {
		return CombinedFlows.COBOP_ONLY;
	}

	if (hasCOB && !hasCOBOP && !hasConsumerFromContributor) {
		return CombinedFlows.COB_ONLY;
	}

	if (hasConsumerFromContributor && !hasCOB && !hasCOBOP) {
		return CombinedFlows.CONSUMER_ONLY;
	}

	return CombinedFlows.CONSUMER_ONLY;
}
